import { mergeAttributes, Node } from '@tiptap/core'
import { CONDITIONAL_SECTION_NODE } from '#src/observation-logic/documentUnits.ts'
import {
  CONDITIONAL_ATTRIBUTES,
  nodeAttributes,
} from '#src/tiptap/nodes/shared.ts'

/* A run of blocks shown or hidden together on a condition. Block content of
 * its own, so it can hold paragraphs, lists and observations, and sits
 * anywhere a block does (a list item included). */
export const ConditionalSectionNode = Node.create({
  name: CONDITIONAL_SECTION_NODE,
  group: 'block',
  content: 'block+',
  defining: true,
  addAttributes() {
    return nodeAttributes(CONDITIONAL_ATTRIBUTES)
  },
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }]
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, { 'data-type': this.name }),
      0,
    ]
  },
})
